var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _rect7, _rect8, _rect9, _rect10, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 400,
    rx: 16,
    fill: "#222163"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 90,
    width: 200,
    height: 220,
    rx: 16,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 130,
    width: 140,
    height: 12,
    rx: 6,
    fill: "#222163"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 110,
    height: 12,
    rx: 6,
    fill: "#9aa0c8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 190,
    width: 140,
    height: 12,
    rx: 6,
    fill: "#222163"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 220,
    width: 90,
    height: 12,
    rx: 6,
    fill: "#9aa0c8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 200,
    r: 36,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 200,
    r: 16,
    fill: "#222163"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 194,
    width: 70,
    height: 12,
    rx: 6,
    fill: "#ffffff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 110,
    width: 70,
    height: 50,
    rx: 12,
    fill: "#ffffff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 175,
    width: 70,
    height: 50,
    rx: 12,
    fill: "#ffffff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 240,
    width: 70,
    height: 50,
    rx: 12,
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 370,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#ffffff"
  }, "AI Agent Data Bridge")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcp);
export default __webpack_public_path__ + "static/media/mcp.f03774ec5995d9e8d3a028218de34899.svg";
export { ForwardRef as ReactComponent };